export default "__VITE_PUBLIC_ASSET__5d4e46ab__"